let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("XaLRQ")).then(() => parcelRequire('1BRiI'));